import React from "react";
import "./ZClubAccountPage.css";
import { Page } from "../../common/components/Page/Page";
import { useZerezesClubAccount } from "../../providers/ZerezesClubAccountProvider";
import { ZClubAccountPageHeader } from "./components/ZClubAccountPageHeader";
import { ZClubAccountPageBody } from "./components/ZClubAccountPageBody";
import { PageBody } from "../../common/components/PageBody/PageBody";
import { Button, Form } from "react-bootstrap";
import { useZerezesServices } from "../../providers/ZerezesServicesProvider";

const ZClubAccountPage = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [userEmail, setUserEmail] = React.useState<string>('');
  const [userPassword, setUserPassword] = React.useState<string>('');
  const [message, setMessage] = React.useState<string>('');

  const {
    ztoken,
    zstore,
    setZParams,
  } = useZerezesClubAccount();

  const {
    getSislogAuthUserService
  } = useZerezesServices();

  React.useEffect(() => {
    document.title = 'clube dos quatro ::';
  }, []);

  const render = () => {
    if (!ztoken || !zstore) {
      return (
        <Page className="zclub-account-page">
          <PageBody>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ width: '100%', margin: '20px 0px', fontWeight: 'bold', fontSize: '1em', textAlign: 'center' }}>
                Entre com o mesmo usuário e senha que você utiliza para acessar o Sislog.
              </div>

              <Form.Control
                type={'email'}
                placeholder={'Usuário'}
                defaultValue={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                autoFocus
                disabled={loading}
                style={{ marginBottom: '15px', padding: '0.6rem 0.7rem' }}
                required
              />
              <Form.Control
                type={'password'}
                placeholder={'Senha'}
                defaultValue={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
                disabled={loading}
                style={{ marginBottom: '15px', padding: '0.6rem 0.7rem' }}
                required
              />
              <Button
                variant='primary'
                title='Entrar'
                onClick={handleLogin}
                disabled={loading}
                style={{ width: '200px' }}
              >
                Entrar
              </Button>

              {message && (
                <div style={{ marginTop: '15px', color: 'red', fontWeight: 'bold', textAlign: 'center' }}>
                  {message}
                </div>
              )}
            </div>
          </PageBody>
        </Page>
      )
    }

    return (
      <Page className="zclub-account-page">
        <ZClubAccountPageHeader />
        <ZClubAccountPageBody />
      </Page>
    );
  }

  return render();

  function handleLogin() {
    if (!userEmail || !userPassword) {
      setMessage('Por favor, preencha o usuário e a senha.');
      return;
    }

    setLoading(true);
    setMessage('');

    const email = userEmail.includes('@') ? userEmail : `${userEmail}@zerezes.com.br`;

    getSislogAuthUserService?.handle({
      email: email,
      password: userPassword
    }).then((result) => {
      if (result?.value?.user?.token) {
        setZParams && setZParams(
          result.value.user.token,
          result.value.locations?.[0]?.name,
          email
        );
      } else {
        setMessage('Usuário ou senha inválidos. Por favor, verifique e tente novamente.');
      }
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      setMessage('Problema ao autenticar. Por favor, tente novamente mais tarde e se o problema persistir avise o time tech zrzs.');
    });
  }

};

export default ZClubAccountPage;